<template>
  <a-table
    :dataSource="dataSource"
    :columns="columns"
    @resizeColumn="handleResizeColumn"
    class="mb40"
  >
    <template #bodyCell="{ column,text, record }">
      <template v-if="column.key === 'deal'">
        <a-button type="link" @click="showEdit(record)">
          编辑
        </a-button>
      </template>
      <template v-if="column.key === 'active'">
        {{ text - 0 === 0 ? '否' : '是' }}
      </template>
    </template>
  </a-table>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      handleResizeColumn: (w, col) => {
        col.width = w
      },
      columns: [
        {
          title: '销量阈值',
          dataIndex: 'salesTarget',
          key: 'salesTarget',
          align: 'center'
        },
        {
          title: '美化倍数',
          dataIndex: 'beautifyMultiplier',
          key: 'beautifyMultiplier',
          align: 'center'
        },

        {
          title: '是否启用',
          dataIndex: 'active',
          key: 'active',
          align: 'center'
        },

        {
          title: '操作',
          key: 'deal',
          align: 'center',
          width: 200
        }
      ],
      ...toRefs(inject('initState'))
    }
  }
}
</script>
